export default __webpack_public_path__ + "static/media/784.49bb7730.png";